import { call, fork, put } from 'redux-saga/effects'
import firebase from '../config/firebase'

import PromotionActions from '../reducers/promotionReducer'

export function* getPromotions() {
  try {
    const dbRef = firebase.firestore().collection('discount_promotions')

    const snapshot = yield call([dbRef, dbRef.get])
    const promotions = {}

    snapshot.forEach(doc => {
      promotions[doc.id] = { ...doc.data(), key: doc.id }
    })

    yield put(PromotionActions.setPromotion(promotions))
    yield put(PromotionActions.setPromotionLoading(false))
  } catch (error) {
    yield put(PromotionActions.setPromotionLoading(false))
  }

  yield put(PromotionActions.setPromotionLoading(true))
}

export function* deletePromotion({ promotionId }) {
  const dataRef = firebase
    .firestore()
    .collection('discount_promotions')
    .doc(promotionId)

  try {
    yield fork([dataRef, dataRef.delete])
  } catch (err) {
    alert(err)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/promotionSaga.js